import { Link } from 'react-router';

export function ForbiddenPage() {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        padding: 40,
        background: 'var(--bg)',
        color: 'var(--text)',
      }}
    >
      <div className="hub-bg" aria-hidden />
      <div className="motion-pop" style={{ position: 'relative', zIndex: 1, maxWidth: 480 }}>
        <span
          style={{
            fontFamily: 'var(--hm-mono)',
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--c-admin)',
            fontWeight: 600,
          }}
        >
          § 403 · not for you
        </span>
        <h1
          style={{
            fontFamily: 'var(--hm-font)',
            fontSize: 44,
            fontWeight: 500,
            letterSpacing: '-0.025em',
            margin: '8px 0 12px',
            lineHeight: 1.08,
          }}
        >
          Door is locked.
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.6 }}>
          Your account is signed in, but this module is not on your
          allowed-pages list. Ask an admin if that is wrong.
        </p>
        <p style={{ marginTop: 18 }}>
          <Link
            to="/dashboard"
            style={{
              fontFamily: 'var(--hm-mono)',
              fontSize: 12,
              color: 'var(--c-ai)',
              borderBottom: '1px solid var(--c-ai)',
              paddingBottom: 2,
            }}
          >
            back to dashboard
          </Link>
        </p>
      </div>
    </div>
  );
}
